import React, { useState, useEffect } from 'react';
import '../Css/Pop.css';
import { X } from 'react-feather';

const PopupModal = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selection, setSelection] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedService, setSelectedService] = useState('');
  

  useEffect(() => {
    const timer = setTimeout(() => setShowPopup(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => setShowPopup(false);

  const handleSubmit = () => {
    let message = '';

    if (selection === 'job') {
      if (phoneNumber) {
        alert('Please enter your phone number. / कृपया अपना फोन नंबर दर्ज करें।');
        return;
      }
      message = `Hello, I am looking for a job. My contact number is: ${phoneNumber}`;
    } else if (selection === 'service') {
      if (!selectedService) {
        alert('Please select a service. / कृपया सेवा चुनें।');
        return;
      }
      message = `Hello, I need a service for: ${selectedService}`;
    } else {
      alert('Please select Job or Service option. / कृपया जॉब या सर्विस विकल्प चुनें।');
      return;
    }

    const whatsappLink = `https://wa.me/919152151180?text=${encodeURIComponent(message)}`;
    window.open(whatsappLink, '_blank');
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content"onClick={(e) => e.stopPropagation()}>
            <div className="popup-close" onClick={closePopup}>
              <X size={24} />
            </div>

            <h2>Need Help?</h2>
            <h3>What are you looking for? <br />आप क्या ढूंढ रहे हैं?</h3>

            {/* Tabs: Always show both */}
            <div className="popup-tabs">
              <button
                className={`popup-tab ${selection === 'service' ? 'active' : ''}`}
                onClick={() => {
                  setSelection('service');
                  setPhoneNumber('');
                }}
              >
                🧑‍🔧 I need a service <br /> मुझे सेवा चाहिए
              </button>

              <button
                className={`popup-tab ${selection === 'job' ? 'active' : ''}`}
                onClick={() => {
                  setSelection('job');
                  setSelectedService('');
                }}
              >
                🧳 I want to work <br /> मैं काम करना चाहता/चाहती हूँ
              </button>
            </div>

            {/* Conditional input based on selection */}
            {selection === 'job' && (
              <input
                type="tel"
                placeholder="🧳 I want to work / मैं काम करना चाहता/चाहती हूँ"
                // value={phoneNumber}
                // onChange={(e) => setPhoneNumber(e.target.value)}
                className="popup-input"
              />
            )}

            {selection === 'service' && (
              <select
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
                className={`popup-select ${selectedService ? 'selected' : ''}`}
              >
                <option value="">-- Select a service / सेवा चुनें --</option>
                <option value="Full-Time Maid">Full-Time Maid / पूर्णकालिक नौकरानी</option>
                <option value="Part-Time Maid">Part-Time Maid / अंशकालिक नौकरानी</option>
                <option value="Cooking Maid">Cooking Maid / खाना बनाने वाली</option>
                <option value="Cleaning Maid">Cleaning Maid / सफाई करने वाली</option>
                <option value="Baby Care">Baby Care / बच्चों की देखभाल</option>
                <option value="Elderly Care">Patient Care / मरीज देखभाल</option>
                <option value="Kitchen Helper">Kitchen Helper / रसोई सहायक</option>
                <option value="Laundry Maid">Laundry Maid / कपड़े धोने वाली</option>
                <option value="Driver cum Maid">Driver cum Maid / ड्राइवर और कामवाली</option>
              </select>
            )}

            {/* Submit & Reset buttons */}
            {selection && (
              <>
                <button onClick={handleSubmit} className="popup-submit-btn">
                  Send via WhatsApp / व्हाट्सएप पर भेजें
                </button>
                <button
                  className="popup-reset-btn"
                  onClick={() => {
                    setSelection('');
                    setPhoneNumber('');
                    setSelectedService('');
                  }}
                >
                  ⬅️ Back
                </button>
              </>
            )}

            <p className="popup-note">
              * We’ll get back to you quickly. / हम आपसे शीघ्र संपर्क करेंगे।
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default PopupModal;
